import script from "./Table.vue?vue&type=script&setup=true&lang=ts"
export * from "./Table.vue?vue&type=script&setup=true&lang=ts"

import "./Table.vue?vue&type=style&index=0&id=4263cf5d&lang=scss"

const __exports__ = script;

export default __exports__